import {copyTextToClipboard} from "../src/components/organisms/DownloadUniversal/DownloadOSItem/utils";
import {sendGaEvent} from "../src/util/ga/gaHelpers";

export const generateCopyButtons = (location) => {
    const codeBoxes = document.querySelectorAll("pre[class^=language-]:not([data-disable-code-copy])")

    for (const box of codeBoxes) {
        const code = box.querySelector("code")
        if(code) {
            const button = document.createElement("button");
            button.className = "code-copy-button"
            button.innerHTML = 'Copy';
            button.addEventListener("click", () => {
                button.innerHTML = 'Copied!';
                setTimeout(() => {
                    button.innerHTML = 'Copy'
                }, 1000);
                copyTextToClipboard(code.textContent)
                try {
                    if (location && location.pathname && ["/pages/package-managers/", "/libericajdk-containers/",
                        "/alpaquita-containers/", "/bellsoft-hardened-container-images/"].includes(location.pathname))
                    sendGaEvent(
                        {
                            'event': 'custom_event',
                            'event_category': 'copy_button',
                            'event_action': "copy_code",
                            'event_label': `Downloads_Copy_${location.pathname}`
                        }
                    )
                } catch (e){}
                const copyEvent = new Event("copy", {
                    bubbles: true
                });
                code.dispatchEvent(copyEvent);
            })
            box.append(button)
        }
    }
}
